function Footer() {
  return (
    <footer className="bg-black text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 md:px-28 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Navigation */}
          <nav className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="/about-us" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="/clients" className="hover:text-white transition-colors">Clients</a></li>
              <li><a href="/candidates" className="hover:text-white transition-colors">Candidates</a></li>
              <li><a href="/contact-us" className="hover:text-white transition-colors">Contact Us</a></li>
            </ul>
          </nav>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy-policy" className="hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/lincoln-aim"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <address className="text-center md:text-left not-italic">
            <h3 className="text-2xl font-bold text-white mb-4">Contact</h3>
            <ul className="space-y-4 text-sm">
              <li>
                <strong className="text-white">Dubai Office</strong><br />
                Reef Tower, Jumeirah Lake Tower, Cluster O<br />
                Dubai, UAE<br />
                Tel: +971 (0)452 94626
              </li>
              <li>
                <strong className="text-white">London Office</strong><br />
                16 Great Queen Street, Covent Garden<br />
                London, United Kingdom WC2B 5AH<br />
                Tel: +44 (0)208 308 9364
              </li>
              <li>
                <strong className="text-white">New York Office</strong><br />
                1 Little W 12th St<br />
                New York, NY 10014, United States<br />
                Tel: +1 (0)845 409 0628
              </li>
              <li>
                Email:{' '}
                <a
                  href="mailto:info@lincolnaim.com"
                  className="text-white underline underline-offset-4 hover:opacity-80 transition-opacity"
                >
                  info@lincolnaim.com
                </a>
              </li>
            </ul>
          </address>

          {/* About */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-4">About Lincoln AIM</h3>
            <p className="text-sm">
              Excellence in tech recruitment across UK, US, and MENA markets.
              Connecting top talent with leading companies.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-8 border-t border-neutral-700 text-center text-sm text-neutral-400">
          © {new Date().getFullYear()} Lincoln AIM. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
